import { render, staticRenderFns } from "./Cultures.vue?vue&type=template&id=dcfeadce&scoped=true"
import script from "./Cultures.vue?vue&type=script&lang=js"
export * from "./Cultures.vue?vue&type=script&lang=js"
import style0 from "./Cultures.vue?vue&type=style&index=0&id=dcfeadce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfeadce",
  null
  
)

export default component.exports